export const isAuthenticated = (state) => {
    return state.auth.isAuthenticated && !!state.auth.token;
};
